import Datepicker from '@/components/datepicker/datepicker.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

const getDefaultDates = (startDate) => {
  const dateFrom = startDate ? new Date(startDate) : new Date()
  const dateTo = startDate ? new Date(startDate) : new Date()
  dateTo.setHours(dateTo.getHours() + 8)
  return {
    dateFrom,
    dateTo
  }
}

export default {
  components: {
    Datepicker,
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      form: getDefaultDates()
    }
  },
  computed: {
    mismatchDatesErr() {
      return this.$moment(this.form.dateFrom) >= this.$moment(this.form.dateTo)
    },
    maxTimeDateStr() {
      return this.form.dateFrom ? this.$moment(this.form.dateFrom).add(1, 'day').toISOString() : ''
    }
  },
  methods: {
    onChangeDateFrom(event) {
      if (this.form.dateTo && this.$moment(this.form.dateTo) < this.$moment(event)) {
        this.form.dateFrom = new Date(this.form.dateTo)
      } else {
        this.form.dateFrom = event
      }
    },
    onChangeDateTo(event) {
      if (this.form.dateFrom && this.$moment(this.form.dateFrom) > this.$moment(event)) {
        this.form.dateTo = new Date(this.form.dateFrom)
      } else {
        this.form.dateTo = event
      }
    },
    onSubmit() {
      this.$refs['observer'].validate().then(async success => {
        if (success && !this.mismatchDatesErr) {
          this.onSubmitSuccess()
        }
      })
    },
    getErrorsArr(errors) {
      const keyArr = Object.keys(errors)
      let result = []
      keyArr.forEach(key => {
        result = [...result, ...errors[key]]
      })
      return result
    }
  }
}